import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { map } from "rxjs/operators";
import { AsyncPipe } from '@angular/common';
import { ToolbarButtonComponent } from '../toolbar-button.component';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-arrow',
    templateUrl: './toolbar-button-arrow.component.html',
    styleUrls: ['./toolbar-button-arrow.component.scss'],
    imports: [ToolbarButtonComponent, AsyncPipe]
})
export class ToolbarButtonArrowComponent {

    @Input() icon = 'arrow';
    @Input() fontSet = '';

    private readonly store: Store = inject(Store);

    readonly isDrawingEnabled$ = this.store.select(
        fromToolbar.isDrawingEnabled
    );

    readonly isActivated$ = this.store.select(
        fromToolbar.selectActivatedDrawingTool
    ).pipe(
        map(activatedTool => activatedTool === 'arrow')
    );

    public toggleArrow() {
        this.store.dispatch(
            ToolbarActions.toggleDrawingTool({ toolName: 'arrow' })
        );
    }
}
